(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["norrviva-studio-split"] && !Shopify.designMode) return;
  try {
    
// Norrviva — Studio split inspiration slideshow: one fixed prev/next pair
// (not per-slide, so the buttons never move) plus a small per-photo thumb
// index, driving native horizontal scroll-snap. Touch swipe is unaffected —
// still plain browser scrolling; this only wires clicks, and only via
// scrollBy/scrollTo on the track itself, so clicking can never scroll the page.
//
// {% javascript %} content is deduplicated per page by Shopify regardless of
// how many instances of this section render (unlike a `<script src>` tag
// printed inside the section markup, which is emitted — and re-executes —
// once per instance). The `data-slideshow-wired` guard below is a second,
// defensive layer in case this ever runs more than once anyway.
document.querySelectorAll('[data-slides]:not([data-slideshow-wired])').forEach(function (track) {
  track.setAttribute('data-slideshow-wired', 'true');
  var art = track.closest('.nvv-studio-split__art');
  var nav = art ? art.querySelector('[data-slide-nav]') : null;
  if (!nav) return;
  var prevBtn = nav.querySelector('[data-slide-prev]');
  var nextBtn = nav.querySelector('[data-slide-next]');
  var jumpBtns = nav.querySelectorAll('[data-slide-jump]');

  function go(dir) {
    var max = track.scrollWidth - track.clientWidth;
    if (dir > 0 && track.scrollLeft >= max - 1) {
      track.scrollTo({ left: 0, behavior: 'smooth' });
    } else if (dir < 0 && track.scrollLeft <= 1) {
      track.scrollTo({ left: max, behavior: 'smooth' });
    } else {
      track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
    }
  }

  if (prevBtn) prevBtn.addEventListener('click', function () { go(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { go(1); });

  jumpBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var index = parseInt(btn.getAttribute('data-slide-jump'), 10) || 0;
      track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
